import {React, Component} from 'react'
import './FormInput.css'


class FormInput extends Component{
    constructor(props){
        super(props)
        this.state = {
           
        }
    }




    render(){
        
        return(
            <span className="FormInput" style={{backgroundColor: this.props.selected ? this.props.color:'white', borderColor:this.props.color, ...this.props.style}}  
                onClick={()=>{
                    this.props.formHandler(this.props.data)
                }}
            >
                {this.props.data}
            </span>
        )
    }
}




export default FormInput;